"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var kendo_react_common_1 = require("@progress/kendo-react-common");
exports.CardBody = function (props) {
    return (React.createElement("div", { style: props.style, className: kendo_react_common_1.classNames('k-card-body', props.className) }, props.children));
};
exports.CardBody.propTypes = {
    className: PropTypes.string
};
